import {DefaultTooltipStaticPropsType} from '../../../../component/chart-tooltip/default-chart-tooltip';
import {getDefaultReactTooltipOptions} from '../../../../layout/chart/chart-const';
import {defaultLineChartOptions} from '../../../../layout/chart/line-chart/line-chart-helper';
import {ChartJsLineOptionsType} from '../../../../layout/chart/line-chart/line-chart-type';

export function getImpressionsDynamicsChartOptions(options: {
    tooltipOptions: DefaultTooltipStaticPropsType;
    showTooltip?: boolean;
    disableAnimation: boolean;
}): ChartJsLineOptionsType {
    return {
        ...defaultLineChartOptions,
        ...(options.disableAnimation
            ? {
                  animation: false,
              }
            : {}),
        plugins: {
            ...defaultLineChartOptions.plugins,
            legend: {
                display: false,
            },
            tooltip: options.showTooltip ? getDefaultReactTooltipOptions(options.tooltipOptions) : {enabled: false},
            datalabels: {
                display: false,
            },
        },
    };
}
